<route>
{
  "meta": {
    "permission": [
      "product.add_priceformula",
      "product.change_priceformula",
      "product.add_priceformulaattributes",
      "product.change_priceformulaattributes"
    ]
  }
}
</route>

<template>
  <v-container fluid class="formula">
    <v-tabs
      class="formula-index--tabs mb-2"
      centered
      color="primary"
      next-icon="fa-chevron-right"
      prev-icon="fa-chevron-left"
      show-arrows
      :icons-and-text="$vuetify.breakpoint.smAndUp"
      v-model="tabs"
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab v-if="checkPermissions.view" href="#tab-formula">
        <span
          v-if="$vuetify.breakpoint.smAndUp"
          class="mt-2"
          v-text="$t('formula')"
        ></span>
        <v-icon :large="$vuetify.breakpoint.smAndUp" dark>fa-cube</v-icon>
      </v-tab>
      <v-tab v-if="checkPermissions.view" href="#tab-formula-model">
        <span
          v-if="$vuetify.breakpoint.smAndUp"
          class="mt-2"
          v-text="$t('formula_model')"
        ></span>
        <v-icon :large="$vuetify.breakpoint.smAndUp" dark>fa-clone</v-icon>
      </v-tab>
      <v-tab
        v-if="checkPermissions.view && checkPermissions.attributes"
        href="#tab-attributes"
      >
        <span
          v-if="$vuetify.breakpoint.smAndUp"
          class="mt-2"
          v-text="$t('formulattributes')"
        ></span>
        <v-icon :large="$vuetify.breakpoint.smAndUp" dark>
          fa-puzzle-piece
        </v-icon>
      </v-tab>
      <v-tabs-items v-model="tabs">
        <v-tab-item value="tab-formula">
          <v-card v-if="tabs === 'tab-formula'" class="mx-2" flat>
            <i-table
              :title="$tc('formula', 1)"
              :headers="headers"
              app="product.priceformula"
              api="formula"
              :opt="{ model: 0 }"
              @click:create="changeRoute({ pk: 'create' })"
              @click:edit="changeRoute"
            >
              <template v-slot:item.name="{ value }">
                <span class="text-capitalize">
                  {{ $tc(value.toLowerCase(), 1) }}
                </span>
              </template>
              <template v-slot:item.attributes="{ item }">
                <v-skeleton-loader
                  v-if="
                    attributes == undefined || attributes[item.pk] == undefined
                  "
                  type="chip"
                  class="mx-auto"
                ></v-skeleton-loader>
                <div v-else>
                  <v-chip
                    v-for="attr_selected in attributes[item.pk].attributes"
                    class="mr-1"
                    color="secondary"
                    small
                    text-color="white"
                    :key="'chips-' + attr_selected.pk"
                  >
                    {{ $tc(attr_selected.name.toLowerCase(), 1) }}
                  </v-chip>
                </div>
              </template>
              <template v-slot:item.formula="{ item }">
                <v-skeleton-loader
                  v-if="
                    attributes == undefined || attributes[item.pk] == undefined
                  "
                  type="text"
                  class="mx-auto"
                ></v-skeleton-loader>
                <span v-else>
                  {{ localTranslate(attributes[item.pk].formula) }}
                </span>
              </template>
            </i-table>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-formula-model">
          <v-card v-if="tabs === 'tab-formula-model'" class="mx-2" flat>
            <i-table
              app="product.priceformula"
              api="formula"
              otherBtn
              :headers="modelFormulaHeaders"
              :opt="{ model: 1 }"
              :title="$tc('formula', 1)"
              @click:create="changeRoute({ pk: 'create' })"
              @click:edit="changeRoute"
              :dontEdit="!isAdmin"
            >
              <template v-slot:otherBtn="{ item }">
                <i-btn
                  :title="$t('clone')"
                  outlined
                  icon="fa-clone"
                  color="info"
                  @click="clone(item)"
                />
              </template>
              <template v-slot:item.name="{ value }">
                <span class="text-capitalize">
                  {{ $tc(value.toLowerCase(), 1) }}
                </span>
              </template>
              <template v-slot:item.attributes="{ item }">
                <v-skeleton-loader
                  v-if="
                    attributes == undefined || attributes[item.pk] == undefined
                  "
                  type="chip"
                  class="mx-auto"
                ></v-skeleton-loader>
                <div v-else>
                  <v-chip
                    v-for="attr_selected in attributes[item.pk].attributes"
                    class="mr-1"
                    color="secondary"
                    small
                    text-color="white"
                    :key="'chips-' + attr_selected.pk"
                  >
                    {{ $tc(attr_selected.name.toLowerCase(), 1) }}
                  </v-chip>
                </div>
              </template>
              <template v-slot:item.formula="{ item }">
                <v-skeleton-loader
                  v-if="
                    attributes == undefined || attributes[item.pk] == undefined
                  "
                  type="text"
                  class="mx-auto"
                ></v-skeleton-loader>
                <span v-else>
                  {{ localTranslate(attributes[item.pk].formula) }}
                </span>
              </template>
            </i-table>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-attributes">
          <formula-attributes v-if="tabs === 'tab-attributes'" ref="attrsTab" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>
<script>
import FormulaAttributes from '../attributes/index.vue'
import { translateFormula } from '@/plugins/formula'
import { mapGetters } from 'vuex'
export default {
  components: {
    FormulaAttributes
  },
  data() {
    return {
      formulas: [],
      attributes: {},
      loading: false,
      tabs: 'tab-formula'
    }
  },
  computed: {
    ...mapGetters({
      show_formula: 'formula/show_formula',
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    checkPermissions() {
      return {
        delete: this.getPermissions([`product.delete_priceformula`]),
        edit: this.getPermissions([`product.change_priceformula`]),
        view: this.getPermissions([`product.view_priceformula`]),
        attributes: this.getPermissions([`product.view_priceformulaattributes`])
      }
    },
    headers() {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text: this.checkPermissions.attributes ? this.$t('attributes') : '',
          value: this.checkPermissions.attributes ? 'attributes' : ''
        },
        {
          text: this.$t('formula'),
          value: 'formula'
        },
        {
          // Esta columna solo la verán los admin del sistema, no de empresa.
          text: this.isAdmin ? this.$t('company') : '',
          value: this.isAdmin ? 'company.name' : ''
        },
        {
          text:
            this.checkPermissions.delete || this.checkPermissions.edit
              ? this.$t('action')
              : '',
          value:
            this.checkPermissions.delete || this.checkPermissions.edit
              ? 'actions'
              : '',
          align: 'center',
          width: '160px'
        }
      ]
    },
    modelFormulaHeaders() {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text: this.checkPermissions.attributes ? this.$t('attributes') : '',
          value: this.checkPermissions.attributes ? 'attributes' : ''
        },
        {
          text: this.$t('formula'),
          value: 'formula'
        },
        {
          text:
            this.checkPermissions.delete || this.checkPermissions.edit
              ? this.$t('action')
              : '',
          value:
            this.checkPermissions.delete || this.checkPermissions.edit
              ? 'actions'
              : '',
          align: 'center',
          width: '160px'
        }
      ]
    }
  },
  methods: {
    changeRoute(item) {
      this.$router.push({
        name: 'formula-pk',
        params: { pk: this.codification({ code: item.pk }) }
      })
    },
    async getFormula() {
      this.loading = true
      const formula = await this.$api.formula.list({})
      this.formulas = formula.data.results
      if (this.$store.getters['utils/getIsloading']) {
        this.$store.dispatch('utils/actionLoading')
      }
      let attributes = {}
      for (let i = 0; i < this.formulas.length; i++) {
        let form = this.formulas[i]
        if (form.attributes && form.attributes.length > 0) {
          await this.$store.dispatch('formula/fetchAttrs', form.attributes)
        }
        let attrs = this.show_formula({
          formula: form.formula,
          attributes: form.attributes
        })
        attributes[form.pk] = attrs
      }
      this.attributes = attributes
      this.loading = false
    },
    clone(item) {
      this.loading = true
      this.$api.formula
        .clone({ pk: item.pk })
        .then(() => {
          this.$toast.success(`${this.$t('formula')} ${this.$tc('created', 1)}`)
          this.getFormula()
          this.loading = false
          this.tabs = 'tab-formula'
        })
        .catch(() => {
          this.loading = false
        })
    },
    localTranslate(formula) {
      return translateFormula(formula, this.$tc.bind(this))
    }
  },
  mounted() {
    this.getFormula()
  }
}
</script>
<style lang="sass">
.v-autocomplete__content .v-list__tile--active
  background-color: var(--primary)
  .v-list__tile__title, .v-list__tile__sub-title
    color: white

.elementList span.v-chip__content
  padding-right: 5px
  padding-left: 20px

.elementList .v-chip__close
  display: none

.elementList:hover .v-chip__close
  display: flex
  margin-right: -5px

.elementList:hover
  padding-right: 0px

.theme--dark.v-tabs.formula-index--tabs > .v-tabs-bar
  background-color: #121212
</style>
